import React from 'react';
import ResumeDraft from './ResumeDraft';
import Tooltip from './Tooltip';
import styles from './ResumeDraft.module.css';

interface MobileTabViewProps {
  activeTab: 'chat' | 'document';
  onTabChange: (tab: 'chat' | 'document') => void;
  document: string;
  children: React.ReactNode; // Chat content
}

const MobileTabView: React.FC<MobileTabViewProps> = ({
  activeTab,
  onTabChange,
  document,
  children
}) => {
  return (
    <>
      {/* Tab Content */}
      {activeTab === 'chat' ? (
        <div className={styles.mobileTabView}>
          <div className={styles.mobileTabHeader}>
            <h3 className={styles.title}>Resume Interview</h3>
          </div>
          <div className={styles.mobileTabContent}>
            {children}
          </div>
        </div>
      ) : (
        <div className={styles.mobileTabView}>
          <div className={styles.mobileTabHeader}>
            <h3 className={styles.title}>Resume Draft</h3>
          </div>
          <div className={styles.mobileTabContent}>
            <ResumeDraft
              document={document}
              isOpen={true}
              onToggle={() => {}}
              width={0} // Not used in mobile view
            />
          </div>
        </div>
      )}

      {/* Tab Navigation */}
      <div className={styles.mobileTabNav}>
        <Tooltip content="Switch to chat view" position="top">
          <button
            className={`${styles.mobileTabButton} ${activeTab === 'chat' ? styles.active : ''}`}
            onClick={() => onTabChange('chat')}
            aria-label="Switch to chat view"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            <span>Chat</span>
          </button>
        </Tooltip>
        <Tooltip content="Switch to resume view" position="top">
          <button
            className={`${styles.mobileTabButton} ${activeTab === 'document' ? styles.active : ''}`}
            onClick={() => onTabChange('document')}
            aria-label="Switch to resume view"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14,2 14,8 20,8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
              <line x1="10" y1="9" x2="8" y2="9"/>
            </svg>
            <span>Resume</span>
          </button>
        </Tooltip>
      </div>
    </>
  );
};

export default MobileTabView;
